<template>
  <div class="user-register">
    <div v-if="!isConfirmUser" class="social_button">
      <div class="address_message">
        {{ t('住所は、「発送依頼」をされた際にご登録いただきます。') }}
      </div>
      <AppleLogin
        :showBorder="true"
        :isLogin="false"
        ></AppleLogin>
      <GoogleLoginServer
        class="google-login"
        :showBorder="true"
        @click="googleLogin"
        @success="googleLogin"></GoogleLoginServer>
    </div>

    <div v-if="!isConfirmUser" class="login_title">
      or
    </div>
    <div v-if="isConfirmUser" class="login_title">
      {{ t('入力情報を確認') }}
    </div>
    <div class="row_area">
      <div class="input-area">
        <div class="user-name">
          <div class="last-name-container">
            <v-text-field
              :label="t('姓')"
              outlined
              v-model="lastName"
              hide-details="auto"
              :disabled="isConfirmUser"
            ></v-text-field>
            <ErrorMessage
              v-if="errorMessageLastName"
              class="error-message"
              :message="errorMessageLastName"
            />
          </div>
          <div v-if="countryId !== '84'" class="first-name-container">
            <v-text-field
              :label="t('ミドルネーム')"
              outlined
              v-model="middleName"
              hide-details="auto"
              :disabled="isConfirmUser"
            ></v-text-field>
            <ErrorMessage
              v-if="errorMessageMiddleName"
              class="error-message"
              :message="errorMessageMiddleName"
            />
          </div>
          <div class="first-name-container">
            <v-text-field
              :label="t('名')"
              outlined
              v-model="firstName"
              hide-details="auto"
              :disabled="isConfirmUser"
            ></v-text-field>
            <ErrorMessage
              v-if="errorMessageFirstName"
              class="error-message"
              :message="errorMessageFirstName"
            />
          </div>
        </div>
        <div class="address_area">
          <v-text-field
            :label="t('電話番号')"
            prepend-inner-icon="mdi-phone"
            outlined
            v-model="tel"
            hide-details="auto"
            :disabled="isConfirmUser"
          ></v-text-field>
          <ErrorMessage
            v-if="errorMessageTel"
            class="error-message"
            :message="errorMessageTel"
          />
        </div>

        <div class="address_area">
          <v-text-field
            :label="t('メールアドレス')"
            prepend-inner-icon="mdi-email"
            outlined
            v-model="mail"
            hide-details="auto"
            :disabled="isConfirmUser"
          ></v-text-field>
          <ErrorMessage
            v-if="errorMessageMail"
            class="error-message"
            :message="errorMessageMail"
          />
        </div>

        <div class="address_area">
          <v-select
            v-if="countryList"
            :label="t('国')"
            outlined
            :items="countryList"
            item-text="name"
            item-value="id"
            v-model="countryId"
            hide-details="auto"
            :disabled="isConfirmUser"
            prepend-inner-icon="mdi-earth"
          ></v-select>
          <ErrorMessage
            v-if="errorMessageCountryId"
            class="error-message"
            :message="errorMessageCountryId"
          />
        </div>

        <div class="address_area">
          <v-select
            v-if="languageList"
            :label="t('言語')"
            outlined
            :items="languageList"
            item-text="name"
            item-value="id"
            v-model="languageId"
            hide-details="auto"
            :disabled="isConfirmUser"
            prepend-inner-icon="mdi-earth"
            @change="changeLanguage"
          ></v-select>
          <ErrorMessage
            v-if="errorMessageLanguageId"
            class="error-message"
            :message="errorMessageLanguageId"
          />
        </div>

        <div class="address_area">
          <v-text-field
            :label="t('パスワード')"
            prepend-inner-icon="mdi-lock"
            outlined
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="togglePassword"
            v-model="password"
            hide-details="auto"
            :disabled="isConfirmUser"
          ></v-text-field>
          <ErrorMessage
            v-if="errorMessagePassword"
            class="error-message"
            :message="errorMessagePassword"
          />
          <v-text-field
            v-if="!isConfirmUser"
            class="confirm-password"
            :label="t('パスワード確認')"
            prepend-inner-icon="mdi-lock"
            outlined
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="togglePassword"
            v-model="confirmPass"
            hide-details="auto"
          ></v-text-field>

          <ErrorMessage
            v-if="errorMessagePassword"
            class="error-message"
            :message="errorMessagePassword"
          />
        </div>

        <div v-if="!isConfirmUser" class="address_area">
          <div class="agree_area">
            <label @click="changeHaveReferralCode">
              <CheckBox
                class="check-box"
                :isChecked="haveReferralCode"
                :isBgWhite="true"
                @handleCheckBoxClick="changeHaveReferralCode"
              />
              <div class="agree_label">
                {{ t('友達紹介コードを持っている') }}
              </div>
            </label>
            <label @click="changeAgreeCheckbox">
              <CheckBox
                class="check-box"
                :isChecked="agreeCheck"
                :isBgWhite="true"
                @handleCheckBoxClick="changeAgreeCheckbox"
              />
              <div class="agree_label">
                <a href="/terms-of-service" target="_blank">{{ t('利用規約') }}</a>
                {{ t('に同意し、会員登録をします') }}
              </div>
            </label>
          </div>
        </div>

        <ErrorMessage
          v-if="showTermError"
          class="error"
          :message="t('利用規約に同意してください')"
        />
        <ToggleBtn
          v-if="!isConfirmUser"
          class="square-button login"
          :text="t('登録')"
          :isAction="canRegister"
          :isDisabled="!canRegister"
          @handleSquareBtnClick="goToConfirmUserRegister"
        />

        <div v-if="isConfirmUser" class="button-area">
          <ToggleBtn
            class="square-button purchase-btn"
            :text="t('戻る')"
            :isAction="false"
            @handleSquareBtnClick="isConfirmUser = false"
          />
          <ToggleBtn
            class="square-button purchase-btn"
            :text="t('登録')"
            :isAction="true"
            @handleSquareBtnClick="register"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import GoogleLoginServer from '@/components/atoms/GoogleLoginServer.vue';
import AppleLogin from '@/components/atoms/AppleLogin.vue';
import CheckBox from '@/components/atoms/CheckBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import t from '@/plugins/i18n';
import ToggleBtn from '@/components/atoms/ToggleBtn.vue';

export default {
  name: 'UserRegister',
  mixins: [t],

  components: {
    CheckBox,
    ErrorMessage,
    GoogleLoginServer,
    AppleLogin,
    ToggleBtn,
  },

  data: () => ({
    lastName: null,
    middleName: null,
    firstName: null,
    tel: null,
    mail: null,
    zipCode: null,
    prefectureId: null,
    country: null,
    shiku: null,
    agreeCheck: false,
    address: null,
    building: null,
    password: null,
    confirmPass: null,
    referralCode: null,
    countryId: '84',
    languageId: '1',
    saveMode: 1,
    errorMessageLastName: null,
    errorMessageFirstName: null,
    errorMessageTel: null,
    errorMessageMail: null,
    errorMessageZipCode: null,
    errorMessagePrefectureId: null,
    errorMessageShiku: null,
    errorMessageAddress: null,
    errorMessageBuilding: null,
    errorMessagePassword: null,
    errorMessageReferralCode: null,
    errorMessageMiddleName: null,
    errorMessageCountry: null,
    errorMessageCountryId: null,
    errorMessageLanguageId: null,
    showTermError: false,
    showPassword: false,
    haveReferralCode: false,
    isConfirmUser: false,
  }),

  computed: {
    ...mapGetters({
      prefectureList: 'prefecture/prefectureList',
      currentAddress: 'zipCode/currentAddress',
      confirmUserResult: 'user/confirmUserResult',
      countryList: 'country/countryList',
      googleCreateResult: 'user/googleCreateResult',
      appendUserResult: 'user/appendUserResult',
      languageList: 'language/languageList',
      currentLanguage: 'user/currentLanguage',
      currentUser: 'user/currentUser',
    }),
    canRegister() {
      if (this.agreeCheck) {
        return true;
      }
      return false;
    },
  },

  watch: {
    currentAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const { result } = newVal;
          this.selectPrefectureId(result[0].prefcode);
          this.inputShiku(`${result[0].address2}${result[0].address3}`);
        }
      }
    },
    confirmUserResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const query = {
            lastName: this.lastName,
            middleName: this.middleName,
            firstName: this.firstName,
            tel: this.tel,
            mail: this.mail,
            zipCode: this.zipCode,
            country: this.country,
            prefectureId: this.prefectureId,
            shiku: this.shiku,
            address: this.address,
            building: this.building,
            password: this.password,
            confirmPass: this.confirmPass,
            referralCode: this.referralCode,
            countryId: this.countryId,
            languageId: this.languageId,
          };
          this.$store.dispatch('setUserInfo', query);
          this.$store.dispatch('user/clearConfirmUserResult');
          // this.$router.push({ path: '/confirm-user-register' });
          this.isConfirmUser = true;
        } else {
          const {
            lastName, middleName, firstName, tel, mail, zipcode, country,
            pref_id: prefId, shiku, address, building, pass,
            referral_code: referralCode, country_id: countryId,
            language_id: languageId,
          } = newVal.errors;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageMail = mail ? mail[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessageCountry = country ? country[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
          this.errorMessagePassword = pass ? pass[0] : null;
          this.errorMessageReferralCode = referralCode ? referralCode[0] : null;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
          this.errorMessageLanguageId = languageId ? languageId[0] : null;
        }
      }
    },
    googleCreateResult(newVal) {
      if (newVal.state === 999) {
        window.alert('This account is already registered.\nPlease log in and enjoy.');
        return;
      }
      window.location.href = '/';
    },
    appendUserResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearAppendUserResult');
          this.$store.dispatch('user/setShowLoginPage', false);
          // OAuthログインページの場合は親コンポーネントに処理を任せる
          if (this.$route.path === '/oauth/login') {
            return;
          }
          this.$router.push('complete-user-register');
        }
      }
    },
  },

  created() {
    this.$store.dispatch('country/setCountryList');
    this.$store.dispatch('language/setLanguageList');
    // this.$store.dispatch('user/setCurrentLanguage', 'jp');
    this.languageId = this.languageList.find((language) => language.code === this.currentLanguage).id;
    this.countryId = this.currentUser.country_id;
  },

  methods: {
    inputLastName(lastName) {
      this.lastName = lastName;
    },
    inputFirstName(firstName) {
      this.firstName = firstName;
    },
    inputMiddleName(name) {
      this.middleName = name;
    },
    inputTel(tel) {
      this.tel = tel;
    },
    inputMail(mail) {
      this.mail = mail;
    },
    inputZipCode(zipCode) {
      this.zipCode = zipCode;
    },
    inputCountry(country) {
      this.country = country;
    },
    selectPrefectureId(prefectureId) {
      this.prefectureId = prefectureId;
    },
    inputShiku(shiku) {
      this.shiku = shiku;
    },
    inputAddress(address) {
      this.address = address;
    },
    inputBuilding(building) {
      this.building = building;
    },
    inputPassword(password) {
      this.password = password;
    },
    inputConfirmPass(confirmPass) {
      this.confirmPass = confirmPass;
    },
    inputReferralCode(referralCode) {
      this.referralCode = referralCode;
    },
    changeAgreeCheckbox() {
      this.agreeCheck = !this.agreeCheck;
    },
    changeHaveReferralCode() {
      this.haveReferralCode = !this.haveReferralCode;
    },
    changeZipCode() {
      if (this.i18n_mode === 'jp') {
        const zipCodeLength = 7;
        if (String(this.zipCode).length === zipCodeLength) {
          const postParams = {
            zipcode: this.zipCode,
          };
          this.$store.dispatch('zipCode/setCurrentAddress', { postParams });
        }
      }
    },
    changeCountry(country) {
      this.countryId = country;
    },
    goToConfirmUserRegister() {
      this.showTermError = false;
      if (!this.agreeCheck) {
        this.showTermError = true;
        return;
      }
      this.prefectureId = 99;
      const postParams = {
        lastName: this.lastName,
        middleName: this.middleName,
        firstName: this.firstName,
        tel: this.tel,
        mail: this.mail,
        // zipcode: this.zipCode,
        // country: this.country,
        // pref_id: this.prefectureId,
        // shiku: this.shiku,
        // address: this.address,
        // building: this.building,
        pass: this.password,
        confirmPass: this.confirmPass,
        referralCode: this.referralCode,
        country_id: this.countryId,
        language_id: this.languageId,
      };
      this.$store.dispatch('user/confirmUser', { postParams });
    },
    changeSaveMode(mode) {
      this.saveMode = mode;
    },
    googleLogin() {
      window.location.href = '/api/user/google/login?create=1';
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    register() {
      const postParams = {
        lastName: this.lastName,
        middleName: this.middleName,
        firstName: this.firstName,
        tel: this.tel,
        mail: this.mail,
        pass: this.password,
        confirmPass: this.confirmPass,
        country_id: this.countryId,
        language_id: this.languageId,
        hasReferralCode: this.haveReferralCode,
      };
      this.$store.dispatch('user/appendUser', { postParams });
    },
    changeLanguage(row) {
      const languageCode = this.languageList.find((language) => language.id === row).code;
      this.$store.dispatch('user/setCurrentLanguage', languageCode);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-register{
  position: relative;
  width: 100%;
  max-width: 600px;
  max-height: 600px;
  padding: 10px 20px 20px;
  margin: 10px auto 0;
  background-color: #fff;
  border-radius: 36px;
  border-top-right-radius: 0;
  color: $baseColor;
  @media screen and  (max-width: $tabletWidth) {
    padding: 10px 20px 60px;
    width: 96%;
  }
  .address_message {
    text-align: center;
    font-size: 12px;
    color: #FF0000;
  }
  .error{
    background-color: rgba(0, 0, 0 ,0)!important;
    color: $red;
    margin-bottom: 10px;
    text-align: center;
  }
  .social_button{
    margin-top: 10px;
    .google-login {
      margin-top: 20px;
    }
    }
  .login_title {
    margin: 20px 0;
    color: $baseColor;
    text-align: center;
  }

  .user-name {
    display: flex;
    div {
      &:nth-child(2) {
        margin: 0 8px;
      }
    }
  }
  .check-box {
    width: 25px;
    height: 25px;
    border: solid 1px $deepColor;
  }

  ._title {
    margin-top: 10px;
  }
  .password{
    &:nth-child(2) {
      margin-top: 10px;
    }
  }

  .agree_area {
    margin-top: 20px;
    margin-bottom: 20px;
    label {
      margin-top: 10px;
      display: flex;
      // justify-content: center;
      align-items: center;
      cursor: pointer;
      .agree_label {
        margin-left: 10px;
        font-size: 12px;
        a {
          color: $baseColor!important;
          text-decoration: underline;
        }
      }
    }
  }

  .message_area {
    div {
      text-align: center;
    }
    .caution {
      color: #FF4545;
      font-size: 14px;
    }
    .message {
      font-size: 12px;
    }
  }
}
.button-area {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .purchase-btn {
    width: 48%;
    border-radius: initial;
  }
}
.login{
  padding-bottom: 15px;
}
.address_area {
  margin-top: 20px;
}
.confirm-password {
  margin-top: 10px;
}
.v-text-field {
  border-radius: 10px;
}
</style>
